// The length limits of the fields people fill in, in one place (#23): the forms read their maxlength and validation
// from here and the server methods check the same values. Shared by the Meteor server and the Quasar client (client
// import: `api/core/limits`). Pure values and checks only. A new field with a limit gets its value here.
// a person's name (fans, owners, the account page)
export var NAME_MIN_LENGTH = 3;
export var NAME_MAX_LENGTH = 25;
export var PASSWORD_MIN_LENGTH = 8; // an owner's organisation

export var ORGANIZATION_MAX_LENGTH = 60; // a community's, area's or other item's title and description (communities, pledges, threads, treasures, ...)

export var TITLE_MAX_LENGTH = 49;
export var DESCRIPTION_MAX_LENGTH = 999; // an admin's reason for rejecting or deleting, which the owner gets to read

export var REJECT_COMMENT_MAX_LENGTH = 1000; // the title of a message or e-mail an admin or owner sends

export var MESSAGE_TITLE_MAX_LENGTH = 100; // one answer of a poll

export var POLL_OPTION_MAX_LENGTH = 120; // how many answers a poll has at most

export var POLL_OPTIONS_MAX = 50; // a meeting's link

export var LINK_MAX_LENGTH = 50; // the search text of the area lists

export var SEARCH_MAX_LENGTH = 200; // what the server accepts as a name: none (accounts from the PBL survey, removed in #509, have none) or text of at most 25 characters after
// trimming (the caller stores it trimmed, so spaces cannot carry a longer one past this); the forms also ask at least
// NAME_MIN_LENGTH, the server not: an empty name stays allowed for those accounts

export var isAcceptedName = function isAcceptedName(name) {
  if (name === undefined || name === null || name === '') return true;
  return typeof name === 'string' && name.trim().length <= NAME_MAX_LENGTH;
}; // the id of one visit's log rows (#577): the pages make it, logs.insert stores no longer session (a login token is 43)

export var LOG_SESSION_LENGTH = 24;